import { Global, Collection, Jobs } from "@sourceflow-uk/sourceflow-sdk";
import SeoHead from "../../components/SeoHead";
import Link from "next/link";
import MainBanner from "../../components/MainBanner";
import LatestJobs from "../../components/LatestJobs";
import NewSimpleContent from "../../components/NewSimpleContent";
import NewImageWithText from "../../components/NewImageWithText";
import AccordionColumnBox from "../../components/AccordionColumnBox";
import NewColumnWithForm from "../../components/NewColumnWithForm";
import FeaturedEmployersImageWithText from "../../components/FeaturedEmployersImageWithText";
import AllJobSearch from "../../components/AllJobSearch";
import LatestNews from "../../components/LatestNews";
import TwoColContentBehavior from "../../components/TwoColContentBehavior";
import { Container } from "reactstrap";
import { DynamicPageSeo } from "@/ui/DynamicPageSeo";
import { ContentBlocks } from "@/ui/ContentBlocks";
import useDynamicPages from "@/hooks/useDynamicPages";

export default function JobSeekersIndividualPage({
  isBuilder,
  title,
  seo,
  canonical,
  data,
  prefix,
  global,
  page,
  all_jobs,
  all_news,
  client_cat_value,
  all_featured_employers_accordion_cards_uk,
}) {

  return (
    isBuilder ? (
      <>
        <DynamicPageSeo
          title={seo?.title || title}
          description={seo?.description || ""}
          canonical={seo?.canonical || canonical}
          keywords={seo?.keywords || ""}
          robots={seo?.robots || ""}
          json_schema={seo?.json_schema || ""}
          image={seo?.open_graph?.image?.url || ""}
        />
        <ContentBlocks data={data} prefix={prefix} />
      </>
    ) : (
      <>
        <SeoHead
          page_name={`${page.title} | The global house of tech and transformation recruitment | Lorien`}
          canonical_link={`job-seekers/${page.url_slug}`}
        />
        {page.new_template_v2 ? (
          <>
            <MainBanner
              global={global}
              pathPrefix={`job_seekers.${page.url_slug}.featured_employers_page.main_banner.new`}
              customClass={`featured-employer-page anchor-offset`}
              content={
                <>
                  {page?.banner_content ? (
                    <div
                      className="post-content"
                      dangerouslySetInnerHTML={{ __html: page?.banner_content }}
                    />
                  ) : (
                    <h1>{page.title}</h1>
                  )}
                </>
              }
              imageURL1={`/site-assets/images/main-banner.jpg`}
              imageALT1={`Main Banner`}
              imageURL2={`${
                page?.banner_image
                  ? page.banner_image
                  : "/site-assets/images/main-banner.jpg"
              }`}
              imageALT2={`Overlay Main Banner`}
              displayImage1={false}
              editableContent={false}
              buttonLink={`#latest-jobs`}
              buttonTitle={`Browse Jobs`}
              returnButtonLink={`/job-seekers/featured-employers`}
              returnButtonTitle={`Back to Featured Employers`}
            />

            <NewImageWithText
              global={global}
              pathPrefix={`job_seekers.${page.url_slug}.new_image_with_text`}
              post={page.image_with_text}
              customClass={`py-5`}
            />
            {page?.new_left_column_content && (
              <NewSimpleContent
                global={global}
                pathPrefix={`job_seekers.${page.url_slug}.new_simple_content.1`}
                customClass={`py-5`}
                content={page?.new_left_column_content}
                content_2={page?.new_right_column_content}
                dual_column={true}
                border_bottom={true}
                editableDualText={false}
              />
            )}
            <TwoColContentBehavior
              global={global}
              title={<h2 style={{color: `${page.values_title_color}`}}>{page.values_title}</h2>}
              items={page.values_content}
            />
            {all_featured_employers_accordion_cards_uk.length >= 1 && (
              <>
                <Container>
                  <hr />
                </Container>
                <AccordionColumnBox
                  global={global}
                  pathPrefix={`job_seekers.${page.url_slug}.new_accordion_card`}
                  customClass={`py-5`}
                  content={
                    <>
                      <h2>Title goes here</h2>
                    </>
                  }
                  post={all_featured_employers_accordion_cards_uk}
                />
              </>
            )}
            <LatestJobs
              global={global}
              pathPrefix={`job_seekers.${page.url_slug}.latest_jobs`}
              customClass={`py-5`}
              post={all_jobs}
              content={
                <>
                  <h2>Jobs from {page.title}</h2>
                  <p>Find the best tech and digital career opportunities.</p>
                </>
              }
              buttonTitle={`View All Jobs`}
              buttonLink={`/jobs/`}
              swiperID={`latestJobsSwiper`}
              locale={`https://www.lorienglobal.com`}
            />
            <NewColumnWithForm
              global={global}
              pathPrefix={`job_seekers.${page.url_slug}.new_column_with_form`}
              customClass={`pb-5`}
              heading={`How can we help you?`}
              formId={`308d12ba-6cc4-44a5-91e2-76d1d714bf23`}
            />
          </>
        ) : (
          <>
            <MainBanner
              global={global}
              pathPrefix={`job_seekers.${page.url_slug}.featured_employers_page.main_banner`}
              customClass={`featured-employer-page anchor-offset`}
              content={
                <>
                  {page?.banner_content ? (
                    <div
                      className="post-content"
                      dangerouslySetInnerHTML={{ __html: page?.banner_content }}
                    />
                  ) : (
                    ""
                  )}
                  {page?.banner_button_new_tab ? (
                    <Link href={`${page?.banner_button_link}`}>
                      <a
                        className="primaryBtn no-arrow"
                        target="_blank"
                        rel="noreferrer noopener"
                      >
                        {page?.banner_button_title}
                      </a>
                    </Link>
                  ) : (
                    <>
                      {page?.banner_button_link ? (
                        <Link href={`${page?.banner_button_link}`}>
                          <a className="primaryBtn no-arrow">
                            {page?.banner_button_title}
                          </a>
                        </Link>
                      ) : null}
                    </>
                  )}
                </>
              }
              imageURL1={`/site-assets/images/main-banner.jpg`}
              imageALT1={`Main Banner`}
              imageURL2={`${
                page?.banner_image
                  ? page.banner_image
                  : "/site-assets/images/main-banner.jpg"
              }`}
              imageALT2={`Overlay Main Banner`}
              displayImage1={false}
              editableContent={false}
            />
            <FeaturedEmployersImageWithText
              global={global}
              pathPrefix={`job_seekers.featured_employers_page.featured_employers_with_with_text`}
              customClass={`py-5 featured-employer-page ${page.url_slug}-page overflow-hidden`}
              post={page?.image_with_text}
              page={page}
              secondary_post={page?.roles}
              pageButtonLink={`/job-seekers/featured-employers/`}
              pageButtonTitle={`Back to featured employers`}
            />
            {page.banner_image_2 ? (
              <MainBanner
                global={global}
                pathPrefix={`job_seekers.${page.url_slug}.featured_employers_page.main_banner_2`}
                customClass={`featured-employer-page page invert none-main-banner`}
                content={
                  <>
                    {page?.banner_image_2_banner_content ? (
                      <div
                        className="post-content"
                        dangerouslySetInnerHTML={{
                          __html: page?.banner_image_2_banner_content,
                        }}
                      />
                    ) : (
                      ""
                    )}
                    {page?.banner_image_2_banner_button_new_tab ? (
                      <Link href={`${page?.banner_image_2_banner_button_link}`}>
                        <a
                          className="primaryBtn no-arrow"
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          {page?.banner_image_2_banner_button_title}
                        </a>
                      </Link>
                    ) : (
                      <>
                        {page?.banner_image_2_banner_button_link ? (
                          <Link
                            href={`${page?.banner_image_2_banner_button_link}`}
                          >
                            <a className="primaryBtn no-arrow">
                              {page?.banner_image_2_banner_button_title}
                            </a>
                          </Link>
                        ) : null}
                      </>
                    )}
                  </>
                }
                imageURL1={`/site-assets/images/main-banner.jpg`}
                imageALT1={`Main Banner`}
                imageURL2={`${page?.banner_image_2 ? page.banner_image_2 : ""}`}
                imageALT2={`Overlay Main Bannr`}
                displayImage1={false}
                editableContent={false}
              />
            ) : (
              ""
            )}
            {page?.image_with_text_2.map((post, index) => (
              <>
                {post.image === null ? (
                  ""
                ) : (
                  <FeaturedEmployersImageWithText
                    global={global}
                    pathPrefix={`job_seekers.featured_employers_page.featured_employers_with_with_text_2`}
                    customClass={`py-5 mt-5 featured-employer-page column-reverse`}
                    post={page?.image_with_text_2}
                    secondary_post={page?.roles}
                    pageButtonLink={``}
                    pageButtonTitle={``}
                  />
                )}
              </>
            ))}
            {page.title == "Careers at Howden" && (
              <h2 className="p-5">{page?.banner_image_2_banner_button_title}</h2>
            )}
            {page.title != "Pheonix Group - Early Careers" &&
              page.title !== "KPMG" && (
                <>
                  <AllJobSearch
                    global={global}
                    pathPrefix={`job_seekers_page.all_job_search`}
                    sectionID={`all-client-jobs`}
                    customClass={`py-5 grayGradientBg position-relative client-jobs`}
                    newsletter_content={
                      <>
                        <h2>Subscribe to our newsletter</h2>
                        <p>
                          With insight across the whole of Lorien, we'll keep you
                          ahead of the curve on the talent market.
                        </p>
                      </>
                    }
                    formId={`308d12ba-6cc4-44a5-91e2-76d1d714bf23`}
                    successPageUrl={"/jobs/subscription-success/"}
                    jobClientFilter={true}
                    client_cat_value={client_cat_value}
                    uk_jobs={true}
                  />
                </>
              )}

            <LatestNews
              global={global}
              pathPrefix={`job_seekers.featured_employers_page.latest_news`}
              customClass={`py-5`}
              post={all_news}
              content={
                <>
                  <h2>The Lorien Pulse: Latest News, Events, and Insights</h2>
                  <p>
                    Our tech expertise and partner-led approach allows us to
                    deliver highly successful results for our clients so they can
                    attract and retain unique talent for their business. Explore
                    our latest collection of case studies, news, events, and
                    insights
                  </p>
                </>
              }
              buttonLink={`/insights/`}
              buttonTitle={`View All Insights`}
            />
          </>
        )}
      </>
    )
  );
}

export async function getStaticProps({ params }) {
  const global = (await Global()).toJson();
  const page = (await Collection("featured_employers")).getJsonItem(
    params.url_slug,
    "url_slug"
  );
  const all_jobs = (await Jobs())
    .filter(function (job) {
      return (
        job.categories
          // Pulls Sectors only
          .find(
            (cat) =>
              cat.id === "269c3235-90e5-44d8-8c69-bdb0c043f331" &&
              cat.values.find((x) => x.id === `${page.id}`)
          )
      );
    })
    .filter(function (job) {
      return (
        job.categories
          // Pulls Sectors only
          .find(
            (cat) =>
              cat.id === "7710db30-b4cf-4029-b846-e02e2f0c9b3b" &&
              cat.values.find((x) => x.name === "United Kingdom")
          )
      );
    })
    .filter(function (job) {
      return new Date(job?.expires_at) >= new Date();
    })
    .getItems()
    .slice(0, 8);

  const featured_employers_accordion_cards_uk = await Collection(
    "featured_employers_accordion_cards_uk"
  );
  const all_featured_employers_accordion_cards_uk =
    featured_employers_accordion_cards_uk
      .orderBy("featured_employers_accordion_cards_uk")
      .getItems();

  const news = (await Collection("news")).filter(function (post) {
    return post.country?.en == "United Kingdom" || post.country?.en == "All";
  });
  const all_news = news.orderBy("date").getItems().slice(0, 8);
  const client_cat_value = page.id;

  return {
    props: {
      global,
      page,
      all_news,
      all_jobs,
      client_cat_value,
      all_featured_employers_accordion_cards_uk,
    },
  };
}

export async function getStaticPaths() {
  const pages = useDynamicPages()
    .filter(function (page) {
      return (
        page.url_slug.includes("job-seekers/")
      );
    })
    .map((i) => (i.url_slug.split("/").pop()));

  const pagePath = (await Collection("featured_employers"))
    .filter(function (post) {
      return (
        !pages.includes(post.url_slug) &&
        post.country?.en == "United Kingdom" && post.url_slug !== "santander"
      );
    })
    .getPaths("url_slug");
  return {
    paths: pagePath,
    fallback: false,
  };
}
